export default __webpack_public_path__ + "static/media/profile.63762773.png";